import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrowright",
  "use": "arrowright-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrowright\"><title>arrowright</title><path d=\"M2.703 7.313h8.969l-3.375-3.25q-.219-.203-.219-.484t.195-.492.477-.211.5.188l4.594 4.438q.219.203.219.492t-.219.492l-4.625 4.453q-.203.188-.469.188-.297 0-.5-.219-.203-.203-.195-.484t.211-.484l3.375-3.25H2.688q-.266 0-.469-.188T2 8.049q-.016-.297.195-.516t.508-.219z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/arrowright.svg
// module id = 472
// module chunks = 0